"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, type CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@repo/design-system/components/ui/carousel";
import { useActiveSection } from "@repo/design-system/hooks/use-active-section";
import { cn } from "@repo/design-system/utils/cn";
import { filterAndSortByDomOrder } from "@repo/design-system/utils/helpers";
import type { KeyboardEvent, MouseEvent } from "react";
import { useEffect, useMemo, useState } from "react";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import type { TranslationsMap } from "~/translations/loader/init";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export const SECTIONSBAR_HEIGHT = 48;
const SCROLL_OFFSET = 120;
const handleNavigation = (e: MouseEvent<HTMLAnchorElement> | KeyboardEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  const href = e.currentTarget.getAttribute("href");
  if (!href) {
    return;
  }
  const element = document.querySelector(href);
  if (!element) {
    return;
  }
  const y = element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
};
export default function SectionBar(t0) {
  const $ = _c(39);
  const {
    job,
    config
  } = t0;
  const t = useLanguage();
  const [api, setApi] = useState();
  const [domReady, setDomReady] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDomReady(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  config?.sectionBarItems;
  let t3;
  bb0: {
    let t4;
    if ($[2] !== config?.sectionBarItems) {
      t4 = config?.sectionBarItems || [];
      $[2] = config?.sectionBarItems;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    const items = t4;
    if (!domReady) {
      t3 = items;
      break bb0;
    }
    let t5;
    if ($[4] !== items) {
      t5 = filterAndSortByDomOrder(items, _temp);
      $[4] = items;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t3 = t5;
  }
  const sectionBarItems = t3;
  let t4;
  if ($[6] !== sectionBarItems) {
    t4 = sectionBarItems.map(_temp2);
    $[6] = sectionBarItems;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const sectionIds = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mode: "proximity"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const activeSection = useActiveSection(sectionIds, t5);
  let t6;
  let t7;
  if ($[9] !== activeSection || $[10] !== api || $[11] !== sectionIds) {
    t6 = () => {
      if (!api) {
        return;
      }
      api.scrollTo(sectionIds.indexOf(activeSection));
    };
    t7 = [api, activeSection, sectionIds];
    $[9] = activeSection;
    $[10] = api;
    $[11] = sectionIds;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      align: "center",
      duration: 15
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeSection || $[16] !== sectionBarItems || $[17] !== t) {
    let t10;
    if ($[19] !== activeSection || $[20] !== t) {
      t10 = item_1 => <CarouselItem className="basis-auto pl-0" key={item_1.section}><span className={cn("flex whitespace-nowrap leading-none", activeSection === item_1.section ? "font-bold opacity-100" : "opacity-60")}><a aria-label={t[item_1.label as keyof TranslationsMap] ?? item_1.label} className="px-2 first:pl-4" data-source="lc" href={`#${item_1.section}`} onClick={handleNavigation}>{t[item_1.label as keyof TranslationsMap] ?? item_1.label}</a></span></CarouselItem>;
      $[19] = activeSection;
      $[20] = t;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    t9 = sectionBarItems.map(t10);
    $[15] = activeSection;
    $[16] = sectionBarItems;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <CarouselContent className="ease-in-out">{t9}</CarouselContent>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== api) {
    t11 = <CarouselNavigation api={api} />;
    $[24] = api;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <div className="relative flex h-full w-full items-center overflow-hidden"><Carousel className="w-full" opts={t8} setApi={setApi}>{t10}{t11}</Carousel></div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== job) {
    t13 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton className="rounded-xl" job={job} />;
    $[29] = job;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== job) {
    t14 = job.data.applicationUrlDirect && <ApplyButton className="rounded-xl" direct={true} job={job} />;
    $[31] = job;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <div className="hidden items-center justify-center gap-3 py-2 font-medium text-base md:flex md:leading-5 print:hidden">{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t12 || $[37] !== t15) {
    t16 = <nav className="outer-container sticky top-16 z-10 border-gray-200 border-b bg-card py-3 font-light text-lg md:py-1"><div className="inner-container flex items-center justify-between gap-4">{t12}{t15}</div></nav>;
    $[36] = t12;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
function _temp2(item_0) {
  return item_0.section;
}
function _temp(item) {
  return item.section;
}
const CarouselNavigation = t0 => {
  const $ = _c(11);
  const {
    api
  } = t0;
  let t1;
  if ($[0] !== api) {
    t1 = () => {
      api?.scrollPrev();
      api?.scrollPrev();
    };
    $[0] = api;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const scrollMultiplePrev = t1;
  let t2;
  if ($[2] !== api) {
    t2 = () => {
      api?.scrollNext();
      api?.scrollNext();
    };
    $[2] = api;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const scrollMultipleNext = t2;
  let t3;
  if ($[4] !== scrollMultiplePrev) {
    t3 = <CarouselPrevious className="absolute -left-2 z-20 size-14 rounded-none border-none bg-linear-to-r from-card via-card to-transparent shadow-none disabled:hidden" onClick={scrollMultiplePrev} />;
    $[4] = scrollMultiplePrev;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== scrollMultipleNext) {
    t4 = <CarouselNext className="absolute -right-9 z-20 size-14 rounded-none border-none bg-linear-to-l from-card via-card to-transparent shadow-none disabled:hidden" onClick={scrollMultipleNext} />;
    $[6] = scrollMultipleNext;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};